
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/healers",
      function () {
        return require("private-next-pages/healers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/healers"])
      });
    }
  